








import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ProjectPhotoGrid extends Vue {
    @Prop() project!: Estate;

    @Prop({ default: "large" }) size!: "large" | "small";

    get gapSize() {
        if (this.size === "large") {
            return "gap-[16px]";
        }

        return "gap-[12px]";
    }

    get image1Height(): string {
        if (this.size === "large") {
            return " h-[220px] lg:h-[420px]";
        }

        return " h-[180px] lg:h-[315px]";
    }

    get image2Height(): string {
        if (this.size === "large") {
            return " h-[110px] lg:h-[260px]";
        }

        return " h-[90px] lg:h-[200px]";
    }

    get image3Height(): string {
        if (this.size === "large") {
            return " h-[110px] lg:h-[260px]";
        }

        return " h-[90px] lg:h-[200px]";
    }

    get images(): Image[] {
        if (this.project.images) {
            return this.project.images;
        }

        return [];
    }
}
